module.exports = __webpack_public_path__ + "img/dz_bg.a9931545.png";